import React from 'react';
import styles from './Pill.module.scss';

// 小圆角标签/徽标
export default function Pill ({children, color = 'green', className = '', iconLeft}) {
    return (
        <span className={[styles.pill, styles[color], className].filter(Boolean).join(' ')}>
            {iconLeft && <span className={styles.icon}>{iconLeft}</span>}
            {children}
        </span>
    );
}
